/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export const HTTPHAProxyEnum = {
    GET_POST_HAPROXY_CONFIG: '/haproxy/config',
    GET_HAPROXY_HEADERS: (serviceId: string): string => {
        return '/haproxy/headers/' + serviceId;
    },
    POST_HAPROXY_HEADERS: '/haproxy/headers/',
    PUT_HAPROXY_HEADERS: (headerID: string) => {
        return '/haproxy/headers/' + headerID;
    },
    DELETE_HAPROXY_HEADER: (headerID: string) => {
        return '/haproxy/headers/' + headerID;
    },
    // Certs
    POST_HAPROXY_CERT_TO_VIP: (serviceId: string): string => {
        return '/haproxy/frontends/' + serviceId + '/certs/';
    },
    PUT_HAPROXY_CERT_TO_VIP: (serviceId: string, certId: string): string => {
        return '/haproxy/frontends/' + serviceId + '/certs/' + certId + '/';
    },
    DELETE_HAPROXY_CERT_FROM_VIP: (serviceId: string, certId: string): string => {
        return '/haproxy/frontends/' + serviceId + '/certs/' + certId + '/';
    }
};
